/** Aniversários — cliente. A data é da conta; a viagem só sabe o dia. */
import type { BirthdayInTrip } from '@nv/core';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

async function pedir<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, { credentials: 'same-origin', ...init, headers: { ...(init?.body ? { 'content-type': 'application/json' } : {}), ...(init?.headers ?? {}) } });
  if (!res.ok) {
    const corpo = (await res.json().catch(() => ({}))) as { message?: string };
    throw new Error(corpo.message ?? `Falha (${res.status})`);
  }
  return (await res.json()) as T;
}

export const aniversariosApi = {
  daViagem: (tripId: string) => pedir<{ birthdays: BirthdayInTrip[] }>(`/api/v1/trips/${tripId}/birthdays`),
  meu: () => pedir<{ birthDate: string | null }>('/api/v1/me/birthdate'),
  guardarMeu: (birthDate: string | null) => pedir<{ birthDate: string | null }>('/api/v1/me/birthdate', { method: 'PUT', body: JSON.stringify({ birthDate }) }),
};

export function useAniversariosDaViagem(tripId: string, ligado = true) {
  return useQuery({ queryKey: ['aniversarios', tripId], queryFn: () => aniversariosApi.daViagem(tripId), enabled: ligado, staleTime: 5 * 60_000 });
}

export function useMeuNascimento() {
  return useQuery({ queryKey: ['meu-nascimento'], queryFn: aniversariosApi.meu, staleTime: 60_000 });
}

export function useGuardarNascimento() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (birthDate: string | null) => aniversariosApi.guardarMeu(birthDate),
    onSuccess: () => {
      void cliente.invalidateQueries({ queryKey: ['meu-nascimento'] });
      void cliente.invalidateQueries({ queryKey: ['aniversarios'] });
    },
  });
}
